import { withPending, withRejected, withFulFilled } from './commons';
import {
  FETCH_SURVEYS_BY_TEXT,
  REMOVE_SURVEY,
  ACTIVE_SURVEY,
  FETCH_SURVEY_BY_ID,
  GET_SURVEYS_PAGES,
  SHARE_SURVEY,
} from '../actions/management';

// initial state
const INITIAL_STATE = {
  surveys: {
    running: false,
    error: null,
    payload: [],
  },
  survey: {
    running: false,
    error: null,
    payload: null,
  },
  surveysPages: {
    running: false,
    error: null,
    payload: [/* {total_results: number, pages_number: number} */],
  },
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  // fetch surveys
  case withPending(FETCH_SURVEYS_BY_TEXT):
    return { ...state, surveys: { running: true }};
  case withRejected(FETCH_SURVEYS_BY_TEXT):
    return { ...state, surveys: { running: false, error: action.payload }};
  case withFulFilled(FETCH_SURVEYS_BY_TEXT):
    return { ...state, surveys: { running: false, payload: [...action.payload.data] }};
    // remove survey
  case withPending(REMOVE_SURVEY):
    return { ...state, surveys: { running: true }};
  case withRejected(REMOVE_SURVEY):
    return { ...state, surveys: { running: false, error: action.payload }};
  case withFulFilled(REMOVE_SURVEY):
    return { ...state, surveys: { running: false, payload: [...action.payload.data] }};
    // active survey
  case withPending(ACTIVE_SURVEY):
    return { ...state, surveys: { running: true }};
  case withRejected(ACTIVE_SURVEY):
    return { ...state, surveys: { running: false, error: action.payload }};
  case withFulFilled(ACTIVE_SURVEY):
    return { ...state, surveys: { running: false, payload: [...action.payload.data] }};
    // fetch survey
  case withPending(FETCH_SURVEY_BY_ID):
    return { ...state, survey: { running: true }};
  case withRejected(FETCH_SURVEY_BY_ID):
    return { ...state, survey: { running: false, error: action.payload }};
  case withFulFilled(FETCH_SURVEY_BY_ID):
    return { ...state, survey: { running: false, payload: action.payload.data }};
    // share survey
  case withPending(SHARE_SURVEY):
    return { ...state, survey: { running: true }};
  case withRejected(SHARE_SURVEY):
    return { ...state, survey: { running: false, error: action.payload }};
  case withFulFilled(SHARE_SURVEY):
    return { ...state, survey: { running: false, payload: action.payload.data }};
    // surveys pages
  case withPending(GET_SURVEYS_PAGES):
    return { ...state, surveysPages: { running: true }};
  case withRejected(GET_SURVEYS_PAGES):
    return { ...state, surveysPages: { running: false, error: action.payload }};
  case withFulFilled(GET_SURVEYS_PAGES): {
    // eslint-disable-next-line camelcase
    const { total_results, pages_number } = action.payload.data;
    return { ...state, surveysPages: { running: false, payload: { total: total_results, pages: pages_number }}};
  }
  // nothing
  default:
    return state;
  }
};

export default execute;
